export enum AppPath {
    ARTICLESTREAM = 'articlestream',
    SOCIAL_DASHBOARD = 'socialdashboard',
    DAILY_UNIQUE_USERS = 'dailyuusdashboard',
    EXACTAG_CONVERTER = 'exactagconverter',
    JETSTREAM = 'jetstream',
    HEATSTREAM = 'heatstream'
}
